module.exports = __webpack_public_path__ + "img/new_c2.e8524d61.png";